<template>
  <div class="main" v-if="!isShow">
    <div class="search">
      <el-button size="mini" type="primary" @click="enterAdd">新增</el-button>
      <div>
      </div>
    </div>
    <div class="BigContent">
      <div class="itemNav">
        <span>
          <el-checkbox v-model="value"></el-checkbox>
        </span>
        <span>序号</span>
        <span>店铺</span>
        <span>公司名</span>
        <span>店铺地址</span>
        <span>创建时间</span>
        <span>操作</span>
      </div>
      <div class="item" v-for="(item,index) in 6" :key="index" @click="dialogFormVisible2 = true">
        <span>
          <el-checkbox v-model="value"></el-checkbox>
        </span>
        <span>{{ index+1 }}</span>
        <span>{{ "weidouke" }}</span>
        <span>微兜客</span>
        <span><a>www.baidu.com</a></span>
        <span>{{ '2020-06-04 04:42' }}</span>
        <span>删除</span>
      </div>
       <!-- 分页 -->
      <div class="pag">
        <el-pagination
          background
          layout="total, sizes, prev, pager, next, jumper"
          :total="30"
          :page-sizes="[20, 50, 100, 200]"
          :page-size="20"
        ></el-pagination>
      </div>
    </div>
  </div>
  <router-view v-else />
</template>

<script>
export default {
  data() {
    return {
      isShow: false, //是否展示二级路由
      dialogFormVisible: false,
      dialogFormVisible2: false,
      form: {
        name: ""
      },
      options: [
        {
          value: "选项1",
          label: "黄金糕"
        },
        {
          value: "选项2",
          label: "双皮奶"
        },
        {
          value: "选项3",
          label: "蚵仔煎"
        },
        {
          value: "选项4",
          label: "龙须面"
        },
        {
          value: "选项5",
          label: "北京烤鸭"
        }
      ],
      value: ""
    };
  },
  created() {
    if (this.$route.path === "/FBaccount/add") {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  },
  watch: {
    $route(to, from) {
      if (to.path === "/FBaccount/add") {
        this.isShow = true;
      } else {
        this.isShow = false;
      }
    }
  },
  methods: {
      enterAdd(){
          this.$router.push({
              path:"/FBaccount/add"
          })
      }
  },
  components: {}
};
</script>

<style lang="less" scoped>
.main {
  background: rgba(255, 255, 255, 1);
  border: 1px solid rgba(235, 237, 248, 1);
  //   height: 100%;
  box-sizing: border-box;
  padding: 20px;
  > .nav {
    height: 50px;
    font-size: 16px;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    color: rgba(0, 0, 0, 1);
    line-height: 50px;
    border-bottom: 1px solid rgba(235, 237, 248, 1);
    padding-left: 20px;
  }
  .oinput {
    width: 300px;
  }
  > .content {
    padding-left: 10%;
    padding-top: 30px;
  }
  .btns {
    text-align: center;
    margin-bottom: 50px;
    margin-top: 20px;
  }
}
// 上传图片
.avatar-uploader .el-upload {
  border: 1px dashed #d9d9d9;
  border-radius: 6px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.avatar-uploader .el-upload:hover {
  border-color: #409eff;
}
.avatar-uploader-icon {
  font-size: 28px;
  color: #8c939d;
  width: 178px;
  height: 178px;
  line-height: 178px;
  text-align: center;
}
.avatar {
  width: 178px;
  height: 178px;
  display: block;
}
.el-form-item {
  margin-bottom: 6px;
}
/deep/ .el-upload.el-upload--text {
  border: 1px dashed #e6e6e6;
}
.BigContent {
  .itemNav,
  .item {
    padding-left: 18px;
    &:hover {
      background-color: #eee;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 16px;
    }
    span:nth-child(1) {
      width: 30px;
      display: inline-block;
      margin-right: 0;
    }
    span:nth-child(2) {
      display: inline-block;
      text-align: center;
      width: 6%;
    }
    span:nth-child(3) {
      display: inline-block;
      text-align: center;
      width: 18%;
    }
    span:nth-child(4) {
      display: inline-block;
      text-align: center;
      width: 20%;
    }
    span:nth-child(5) {
      display: inline-block;
      text-align: center;
      width: 24%;
      >a{
        color: #1980FF;
      }
    }
    span:nth-child(6) {
      display: inline-block;
      text-align: center;
      width: 16%;
    }
    span:nth-child(7) {
      display: inline-block;
      text-align: center;
      width: 10%;
      &:hover {
        cursor: pointer;
      }
    }
  }
  .itemNav {
    margin-bottom: 10px;
    &:hover {
      background-color: #fff;
    }
  }
  .item {
    background: rgba(246, 249, 252, 1);
    margin-bottom: 5px;
    display: flex;
    align-items: center;
    height: 48px;
    &:hover{
      cursor: pointer;
    }
    span {
      font-size: 14px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(51, 51, 51, 1);
    }
    span:nth-child(7) {
      color: #1980ff;
    }
  }
  .pag {
    margin: 22px 0;
    text-align: center;
    /deep/ .btn-prev,
    /deep/ .btn-next {
      padding: 0 8px;
    }
  }
}
.search {
  margin-bottom: 20px;
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    > div {
      margin-right: 20px;
    }
  }
  > div:last-child {
    margin-right: 0px;
  }
  .searchInput {
    width: 200px;
    border-radius: 0px;
    /deep/ .el-input__inner {
      border-radius: 4px;
    }
  }
  .searchBtn {
    height: 40px;
    background: rgba(0, 119, 255, 1);
    border-radius: 0px 3px 3px 0px;
  }
  .dialog-footer {
    text-align: center;
  }
}
</style>